/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { lazy, ReactNode, Suspense } from "react";

import {
	EdsIconType,
	IconColor,
	EdsGradientType,
	IconSize,
	DeprecatedEdsIconType,
	CustomEdsIconType,
} from "./EdsIcon.type";
import { EdsIconsEnum } from "@cosmos/hygraph-schema";

type NonNullable<T> = Exclude<T, null | undefined>;

export type CosmosIconsType = EdsIconType | DeprecatedEdsIconType | EdsIconsEnum | CustomEdsIconType;
export type CosmosIconsTypeStrict = NonNullable<CosmosIconsType>;

export type EdsIconProps = {
	icon?: CosmosIconsType | null;
	color?: IconColor;
	size?: IconSize;
	gradient?: EdsGradientType | null;
	className?: string | null;
};

const LazyEdsIconInner = lazy(() => import("./EdsIcon.inner").then((m) => ({ default: m.EdsIconInner })));

export const EdsIcon = (props: EdsIconProps): ReactNode => {
	if (!props.icon) return undefined;

	return (
		<Suspense>
			<LazyEdsIconInner {...props} />
		</Suspense>
	);
};
